import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {SmartGridService} from '@core/services/smart-grid.service';
import {AdminPanelConfig} from '@features/admin-panel/admin-panel.config';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-admin-panel-company-user-list',
  templateUrl: './admin-panel-company-user-list.component.html',
  styleUrls: ['./admin-panel-company-user-list.component.scss'],
})
export class AdminPanelCompanyUserListComponent implements OnInit, OnDestroy, IPlatformToolComponent {

  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;

  sourceType = 'Company-User';

  private unsubscribe$ = new Subject<void>();

  constructor(private smartGridService: SmartGridService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onLoad(): void {
    const companyId = this.selectedTab?.tabData?.['CompanyId'];
    if (companyId) {
      AdminPanelConfig.setCompanyId(this.sourceType, companyId);
      this.smartGridService.initDataProvider(this.sourceType);
    }
    // invalidateSubject is set by tab-bar before onLoad() is called
    this.invalidateSubject?.getObservale()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.refreshGrid());
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse): void {}
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse): void {}
  onBeforeExecuteNextCommand(): boolean { return false; }
  onBeforeExecutePreviousCommand(): boolean { return false; }

  onValueChanged(event: any): void {}

  private refreshGrid(): void {
    const companyId = this.selectedTab?.tabData?.['CompanyId'];
    if (companyId) {
      this.smartGridService.initDataProvider(this.sourceType);
    }
  }
}
